import axios from 'axios';
import store from '@/store/index'

const Axios = axios.create({
    timeout: 30000,
    responseType: 'json',
    withCredentials: true,
    headers: {
        "Content-Type": "multipart/form-data"
    }
});

var layerIdx;
var layerConfig = true;
// 请求前置拦截器
Axios.interceptors.request.use(
    config => {
        config.headers.Authorization = `Bearer ${store.state.user.token}` || ""
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 返回响应拦截器
Axios.interceptors.response.use(
    res => {
        if (res.status === 200) {
            return res.data;
        }
        return res;
    },
    error => {
        // if (error.response.status == 401) { //登录信息失效
        //     util.cookies.removeToken()
        //     window.location.href = window.location.href.replace(/#.*/, '#/login')
        // }
        return {
            error
        };
    }
);

const request = (url, data = {}, method = 'post') => {
    return new Promise((resolve, reject) => {
        Axios({
            method: "post",
            url: url,
            data,
        }).then(res => {
            if (res.code == 0) {
                resolve(res.data)
            } else if (res.code == 401) {
                util.cookies.removeToken()
                window.location.href = window.location.href.replace(/#.*/, '#/login');
            } else {
                reject(res)
            }
        }).catch(error => {
            reject(error)
        })
    });
};

export default request;
